import { render, staticRenderFns } from "./PxCamposCompraViewNeo.vue?vue&type=template&id=758c52b6&"
import script from "./PxCamposCompraViewNeo.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraViewNeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports